/**
 * @returns mapRange(0.5, 0, 1, 0, 100) = 50
 */
export default function mapRange(
  val: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number
) {
  return ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}
